import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../../store';

const slice = (state: RootState) => state.loader;

export const isLoadingQuery = createSelector(slice, (state) => state.isLoading);
